import { render, staticRenderFns } from "./call-block.vue?vue&type=template&id=50e750f0"
import script from "./call-block.vue?vue&type=script&lang=ts"
export * from "./call-block.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports